import { useCallback, useState } from "react";
import adminApi from "../api/adminApi";
import { INITIAL_ACTION_DATA } from "../utils/defaults";

export function useAdminUsers({ adminToken }) {
  const [searchId, setSearchId] = useState("");
  const [user, setUser] = useState(null);
  const [actionData, setActionData] = useState(INITIAL_ACTION_DATA);

  const search = useCallback(async () => {
    if (!searchId || !adminToken) return;
    try {
      const res = await adminApi.searchUser(adminToken, Number(searchId));
      setUser(res.data?.user || null);
      if (!res.data?.user) {
        window.alert("Пользователь не найден");
      }
    } catch (error) {
      console.error(error);
      setUser(null);
      window.alert("Пользователь не найден");
    }
  }, [adminToken, searchId]);

  const runAction = useCallback(async (actionType) => {
    if (!user || !adminToken) return;
    try {
      const payload = { id: user.id };

      if (actionType === "balance") {
        const amount = Number(actionData.balance);
        if (amount >= 0) {
          payload.action = "giveBalance";
          payload.amount = amount;
        } else {
          payload.action = "removeBalance";
          payload.amount = Math.abs(amount);
        }
      }

      if (actionType === "premium") {
        const plan = Number(actionData.premiumId);
        if (plan === 0) {
          payload.action = "removeSubscription";
        } else {
          payload.action = "giveSubscription";
          payload.plan = plan;
          payload.days = Number(actionData.premiumDays);
        }
      }

      const res = await adminApi.runUserAction(adminToken, payload);
      setUser(res.data?.user || null);
      window.alert("Действие успешно выполнено");
    } catch (error) {
      console.error(error);
      window.alert("Ошибка при выполнении действия");
    }
  }, [actionData.balance, actionData.premiumDays, actionData.premiumId, adminToken, user]);

  return {
    state: {
      searchId,
      user,
      actionData
    },
    actions: {
      setSearchId,
      setActionData,
      search,
      runAction
    }
  };
}

export default useAdminUsers;
